<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 67 94"
         xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Слой_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <path class="fill-black" :class="{'inter-active': selected}"
                  d="M21 81c-4,-10 -8,-12 -12,0 -3,11 -4,11 -9,13 5,-11 3,-11 7,-19 6,-12 12,-10 16,4 2,5 14,14 22,-8 3,-7 7,-7 12,4 4,8 4,8 9,19 -5,-2 -6,-4 -10,-13 -5,-11 -7,-8 -13,1 -4,7 -15,14 -23,-1z"></path>
            <path class="inter-fill inter-stroke" :class="{'inter-active': selected}"
                  d="M44 14c0,0 0,0 0,4m-27 49c3,1 5,5 7,11 2,5 14,14 22,-8 0,-1 1,-2 1,-3m-30 -1c-1,-7 1,-11 -1,-17 -1,-4 -5,-7 -6,-12 0,-14 1,-27 17,-37 7,-4 14,7 16,12 2,-4 10,-5 12,-1 5,17 -1,36 -8,55"></path>
        </g>
    </svg>
</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'

    export default {
        mixins: [implantMixin]
    }
</script>

<style scoped>

</style>
